import { Component, EventEmitter, Input, Output, TemplateRef, Type, ViewChild, ViewContainerRef } from "@angular/core";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { NgIf, NgStyle } from "@angular/common";

@Component({
    selector: "app-modal",
    standalone: true,
    imports: [SvgIconComponent, NgIf, NgStyle],
    templateUrl: "./modal.component.html",
    styleUrl: "./modal.component.scss"
})
export class ModalComponent {
    @Input() title: string = "";
    @Input() iconUrl: string = "";
    @Output() close = new EventEmitter<void>();
    @Output() primaryActionBtnEmitter = new EventEmitter<any>();
    @Input() showActionBtns = false;
    @Input() primaryActionBtnText = 'Save';
    @Input() secondaryActionBtnText = 'Cancel';
    @Input() hidePrimaryButton?: boolean = false;
    @Output() refreshParent = new EventEmitter<void>();
    @Input() width?: string;
    @Input() height?: string;
    @Input() scrollable: boolean = true;

    @ViewChild("modalContent", { read: ViewContainerRef, static: true }) modalContent!: ViewContainerRef;

    onClose(params?: any) {
        this.close.emit(params);
    }

    loadComponent(componentOrTemplate: Type<any> | TemplateRef<any>, data?: Partial<any>): any {
        this.modalContent.clear(); // Clear any previously loaded content

        if (componentOrTemplate instanceof TemplateRef) {
            return this.modalContent.createEmbeddedView(componentOrTemplate, { $implicit: data });
        } else {
            const componentRef = this.modalContent.createComponent(componentOrTemplate);
            // Pass the closeModal function to the dynamically loaded component
            if (componentRef.instance) {
                (componentRef.instance as any).closeModal = this.onClose.bind(this);
                if (data) {
                    Object.assign(componentRef.instance, data); // Pass the data to the component
                }
            }
            return componentRef;
        }
    }

    handlePrimaryBtnClick() {
        this.primaryActionBtnEmitter.emit();
    }
}
